/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Preview_Image_AltInputs */



/**
* | output |
* | --- |
* | "Subtitle Preview" |
*
* @param {Image_Export_Preview_Image_AltInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_preview_image_alt = /** @type {((inputs?: Image_Export_Preview_Image_AltInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Preview_Image_AltInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Previsualisation des sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitel-Vorschau")
	if (locale === "it") return /** @type {LocalizedString} */ ("Anteprima dei sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительный просмотр субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vista previa de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕预览")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕プレビュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक पूर्वावलोकन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pré-visualização da legenda")
	return /** @type {LocalizedString} */ ("Subtitle Preview")
});